import { ManagePracticeService } from './../../manage-practice/manage-practice.service';

import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { AppSettingService } from 'src/app/services/app-setting.service';

declare var myExtObject: any;
@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.css'],
 // changeDetection: ChangeDetectionStrategy.OnPush
})
export class LeftMenuComponent implements OnInit, OnDestroy {

  public mainMenuItems: any;
  public moreMenuItems: any;
  public otherMenuItems: any;
  public isMainMenuSelected: boolean;
  public backColor: string = '';
  @Input() showMenu: boolean = true;
  employerLogoUrl: string;
  employerBGUrl: string;
  loggedInUser: any;
  advertiseImage: string = "";
  adVertisementUrl: string = "";
  supportedLangs: any
  profilePic: any;
  public providerBadges: any;
  public notificationCount:number;

  public showBBPromotionalImage: string = this.appSettingService.loggedInUser.ShowBBPromotionalImage;
  constructor(
    private managePracticeService:ManagePracticeService,
    private changeDetector: ChangeDetectorRef, private route: Router, private activatedRoute: ActivatedRoute, private appSettingService: AppSettingService) {

    this.supportedLangs = this.appSettingService.supportedLangs
   
    if (this.appSettingService.loggedInUser) {

      this.showBBPromotionalImage = this.appSettingService.loggedInUser.ShowBBPromotionalImage;
    }


    this.appSettingService.SetClassOnBody(this.activatedRoute);
    this.appSettingService.profilePic.subscribe(res => {
      this.profilePic = res;
      this.changeDetector.markForCheck();
    })
  }
  getTranslatedMenu(item: any) {

    return (this.appSettingService.currentLanguage == null || this.appSettingService.currentLanguage == "en") ? item.Caption : item.SpanishCaption
  }

  isRouterActive(routerName: string) {
    var routerClassName = ""
    this.activatedRoute
      .data.subscribe(className => {
        routerClassName = className["activeClass"];
      });
    if (routerClassName == routerName)
      return 'active';
    else '';


  }


  load() {

    myExtObject.executeStartScript();

  }

  ngOnInit() {
    if (this.appSettingService.loggedInUser) {

      

      this.managePracticeService.getBadges().subscribe(res => {
        setTimeout(() => {
          this.providerBadges = res;
          console.log(this.providerBadges);
          myExtObject.UpdateBadgeCount(res);
          
        },50);
      });
      var routerClassName = ""
      this.activatedRoute
        .data
        .subscribe(className => {
          routerClassName = className["activeClass"];
          document.getElementById('body').className = routerClassName;

        });

      this.appSettingService.profileDetail.subscribe(res => {
        this.appSettingService.loggedInUser = res;
        this.loggedInUser = this.appSettingService.loggedInUser;
      });

      this.loggedInUser = this.appSettingService.loggedInUser;

      this.advertiseImage = this.loggedInUser.AdVertisementImage;// this.appSettingService.loggedInUser.AdvertiseImage;
      this.employerLogoUrl = this.loggedInUser.LogoUrl;

      this.employerBGUrl = this.loggedInUser.CompanyBackgroundUrl;
      this.appSettingService.profilePic.next(this.loggedInUser.AvatarUrl);
      this.adVertisementUrl = this.loggedInUser.AdVertisementUrl
      let menus = this.loggedInUser.Menus || [];

      this.mainMenuItems = JSON.parse(menus).MainMenus || [];
      this.moreMenuItems = JSON.parse(menus).MoreMenus || [];

      var mainMenuItem = this.mainMenuItems.find(m => (m.Link.indexOf(this.route.url) >= 0) || (m.CssClass.indexOf(routerClassName) >= 0));
      var moreMenuItem = this.moreMenuItems.find(m => (m.Link.indexOf(this.route.url) >= 0) || (m.CssClass.indexOf(routerClassName) >= 0));

      if (mainMenuItem) {
        this.isMainMenuSelected = true;
        myExtObject.removeMenuCalss('active')
      }
      else if (moreMenuItem) {
        this.isMainMenuSelected = false;
        myExtObject.addMenuCalss('active')
      }
      else {
        this.isMainMenuSelected = true;
        myExtObject.removeMenuCalss('active')
      }

     this.notificationCount = parseInt(this.loggedInUser.AcknowledgeNotificationsCount) + parseInt(this.loggedInUser.UnreadNotifications);

      console.log(this.mainMenuItems);
     
    }

  }
  moreMenus(selected: boolean) {
    this.isMainMenuSelected = !selected;
  }

  logout() {
    this.appSettingService.logout();
    this.route.navigate(["/login"]);
  }
  mouseEnter(color, event) {

    event.target.style.backgroundColor = color;
    //  this.backColor = color;
  }
  mouseleave(event) {
    event.target.style.backgroundColor = "";
  }

  ngOnDestroy() {
    this.mainMenuItems = null;
    this.moreMenuItems = null;
    this.otherMenuItems = null;

    this.loggedInUser = null;
    this.advertiseImage = null;
    this.adVertisementUrl = null;
    this.profilePic = null;

  }
}
